import Axios, {AxiosResponse} from "axios"

export interface Commit {
  id: string
  time: string
}

export interface Git {
  branch: string
  commit: Commit
}

export interface Build {
  time: string
  number: string
  spring: string
}

export interface ActuatorInfo {
  git?: Git
  build?: Build
  maintenanceMessage: string
}

/**
 * Fetches and caches the contents of the /actuator/info endpoint, so multiple
 * components can share the same data without triggering duplicate requests.
 */
export class ActuatorService {
  info: ActuatorInfo | null = null

  private fetchPromise: Promise<ActuatorInfo> | null = null

  async getInfo(): Promise<ActuatorInfo> {
    if (this.info) {
      return this.info
    }

    if (!this.fetchPromise) {
      this.fetchPromise = Axios.get("/actuator/info").then(
        (response: AxiosResponse<ActuatorInfo>) => response.data
      )
    }

    this.info = await this.fetchPromise

    return this.info
  }

  reset(): void {
    this.info = null
    this.fetchPromise = null
  }
}
